export default __webpack_public_path__ + "static/media/Yellow0000.1ae9d2ab.png";